export type SearchTermsMatch = (input: string | undefined) => boolean;

export function matchTextFilter(searchTerm: number | string | undefined): SearchTermsMatch {
  const term = searchTerm && searchTerm.toString().trim().toLowerCase();

  if (term) {
    return (input: string | undefined) => !!input && input.toLowerCase().includes(term);
  }

  return () => true;
}

export function matchText(text: string | undefined, searchTerm: string) {
  return !!text?.toLowerCase().includes(searchTerm.toLowerCase());
}
